import _ from 'lodash'

export function deleteEntries (array, test) {
  safeArray(array, () => {
    _.forEachRight(array, (it, index) => {
      if (test(it)) {
        array.splice(index, 1)
      }
    })
  })
}

export function deleteEntry (array, test) {
  safeArray(array, () => {
    let index
    if (typeof test === 'function') {
      index = array.findIndex(test)
    } else {
      index = array.indexOf(test)
    }

    if (index > -1) {
      array.splice(index, 1)
    }
  })
}

/**
 * Replaces the provided newEntry in the array
 * @param array - The array to replace on
 * @param newEntry - The new entry that will replace the old one. If the { newEntry } is { null } or { undefined }
 *                   the matching element will just be removed
 * @param test - If a { function } is provided it will be used to find the index of the element to replace
 *               if a { string } is provided it will be used as the { id } of the entries to find the element to replace
 */
export function replaceEntry (array, newEntry, test) {
  safeArray(array, () => {
    let index = -1
    if (typeof test === 'function') {
      index = array.findIndex(test)
    } else if (typeof test === 'string') {
      index = array.findIndex(it => it[test] === newEntry[test])
    }

    if (index > -1) {
      if (_.isNil(newEntry)) {
        array.splice(index, 1)
      } else {
        array.splice(index, 1, newEntry)
      }
    }
  })
}

function safeArray (array, func) {
  if (!_.isNil(array)) {
    func()
  }
}

export function toggleItemInList (list, item, selected, findIndex) {
  safeArray(list, () => {
    const index = typeof findIndex === 'function' ? findIndex(list, item) : list.indexOf(item)

    if (selected) {
      if (index === -1) {
        list.push(item)
      }
    } else {
      if (index > -1) {
        list.splice(index, 1)
      }
    }
  })
}

export function toggleItemsInList (list, items, selected, findIndex) {
  for (const item of items) {
    toggleItemInList(list, item, selected, findIndex)
  }
}
